import { Phone, CalendarClock } from "lucide-react";
import { useConsultationModal } from "@/hooks/use-consultation-modal";
import { useLocale } from "@/lib/i18n/locale";

/**
 * Sticky bottom CTA bar — mobile only.
 * Gives patients one-tap access to call or request a consultation
 * from anywhere on the site. Disappears on lg+ where the
 * desktop nav phone button and inline CTAs handle the same job.
 */
const StickyMobileCta = () => {
  const { openConsultation } = useConsultationModal();
  const { isEs } = useLocale();

  // On /namiwalks, the page provides its own dedicated "JOIN OUR TEAM" mobile bar
  if (
    typeof window !== "undefined" &&
    (window.location.pathname === "/namiwalks" ||
      window.location.pathname.startsWith("/namiwalks"))
  ) {
    return null;
  }

  const callLabel = isEs ? "Llamar" : "Call Us";
  const consultLabel = isEs ? "Consulta gratis" : "Free Consultation";

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-30 lg:hidden"
      aria-label="Quick contact bar"
    >
      <div className="flex items-stretch gap-0 border-t border-border bg-background/95 pb-[env(safe-area-inset-bottom)] shadow-[0_-4px_20px_-8px_rgba(0,0,0,0.15)] backdrop-blur-md">
        <a
          href="tel:9548279793"
          className="flex flex-1 flex-col items-center justify-center gap-0.5 py-2.5 text-foreground/80 transition-colors hover:bg-muted active:bg-muted"
        >
          <Phone className="h-5 w-5 text-accent" />
          <span className="text-xs font-bold leading-none">{callLabel}</span>
        </a>
        <button
          onClick={() => openConsultation("sticky-mobile-cta")}
          className="flex flex-[1.5] flex-col items-center justify-center gap-0.5 bg-gradient-accent py-2.5 text-accent-foreground transition-opacity hover:opacity-90 active:opacity-95"
        >
          <CalendarClock className="h-5 w-5" />
          <span className="text-xs font-bold leading-none">{consultLabel}</span>
        </button>
      </div>
    </div>
  );
};

export default StickyMobileCta;
